export class LoaderStatus {
    isLoading: boolean;
}

export async function executeWithLoader(loaderStatus: LoaderStatus, executable: any): Promise<any> {
    try {
        loaderStatus.isLoading = true;
        return await executable();
    } catch (error) {
        loaderStatus.isLoading = false;
        throw error;
    } finally {
        loaderStatus.isLoading = false;
    }
}